<!-- <div class="middle-box text-center loginscreen animated fadeInDown"> -->
<div class="CustomMiddleBox text-center loginscreen animated fadeInDown MainDiv">
	<!--Logo and Info-->
	<div>
		<!--Logo-->
		<div>
			<img alt="image" src="assets/images/CAASS_LOGO_NEW.png" width="190" style="margin-top: 2px" />
			<h3>Welcome to CAASS®</h3>
		</div>

		<div style="margin-bottom: 30px">
			<p>...Logging in Please Wait</p>
		</div>

		<i class="pi-spin pi pi-spinner" style="font-size: 45px; margin-bottom: 15px"></i>
	</div>

	<!--Access 411 Logo-->
	<div style="margin-top: 75px">
		<div>
			<a target="_blank" href="https://www.access411.com"> <img alt="www.access411.com" src="assets/images/access411-bluelogo.png" width="50" /></a>
		</div>

		<div>
			<p class="m-t"><small>Access411 &copy;2022</small></p>
		</div>
	</div>
</div>
